// ** React Imports
import { useEffect, useState } from 'react'

// ** MUI Imports
import Box from '@mui/material/Box'
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'

// ** Store & Actions Imports
import { useDispatch, useSelector } from 'react-redux'
import { selectMessage, fetchUserProfile, fetchChatsContacts, removeSelectedChat } from 'src/store/apps/tinder'

// ** Hooks
import { useSettings } from 'src/@core/hooks/useSettings'

// ** Utils Imports
import { getInitials } from 'src/@core/utils/get-initials'
import { formatDateToMonthShort } from 'src/@core/utils/format'

// ** Chat App Components Imports
import TinderSideBar from 'src/@core/components/tinder/tinder-side-bar'
import TinderContent from 'src/@core/components/tinder/tinder-content'
import TinderContacts from 'src/@core/components/tinder/tinder-contacts'
import ContentLoading from 'src/components/ContentLoading'

const callData = {
  contacts: [
    {
      id: 1,
      name: 'DianeDong',
      img: '/images/tinder/1.jpg'
    },
    {
      id: 2,
      name: 'CatherineLuo',
      img: '/images/call-log/3.webp'
    },
    {
      id: 3,
      name: 'JasonZhou',
      img: '/images/call-log/2.webp'
    },
    {
      id: 4,
      name: 'SusanWang',
      img: '/images/call-log/4.webp'
    },
    {
      id: 5,
      name: 'ZoeSharonLi',
      img: '/images/call-log/5.webp'
    },
    {
      id: 6,
      name: 'Smith',
      img: '/images/tinder/6.jpg'
    },
    {
      id: 7,
      name: 'HelenGuan',
      img: '/images/call-log/7.webp'
    },
    {
      id: 8,
      name: 'Sammy',
      img: '/images/call-log/8.webp'
    },
    {
      id: 9,
      name: 'MayWang',
      img: '/images/call-log/9.webp'
    },
    {
      id: 12,
      name: 'JetLi',
      img: '/images/call-log/2.webp'
    },
    {
      id: 13,
      name: 'RiverLiu',
      img: '/images/call-log/3.webp'
    },
    {
      id: 14,
      name: 'Nick',
      img: '/images/call-log/4.webp'
    },
    {
      id: 15,
      name: '+6180650048',
      img: '/images/call-log/5.webp'
    },
    {
      id: 16,
      name: '+6176429832',
      img: '/images/call-log/6.webp'
    },
    {
      id: 17,
      name: 'Toni',
      img: '/images/call-log/2.webp'
    },
    {
      id: 18,
      name: '+6105280088',
      img: '/images/call-log/8.webp'
    },
    {
      id: 20,
      name: 'James',
      img: '/images/call-log/10.webp'
    },
    { id: 21, name: 'IceLi', img: '/images/call-log/5.webp' },
    {
      id: 22,
      name: 'Amy',
      img: '/images/call-log/12.webp'
    },
    {
      id: 23,
      name: 'Rebecca',
      img: '/images/call-log/11.webp'
    }
  ]
}

const Tinder = () => {
  // ** States
  const [userStatus, setUserStatus] = useState('online')
  const [leftSidebarOpen, setLeftSidebarOpen] = useState(false)
  const [userProfileLeftOpen, setUserProfileLeftOpen] = useState(false)
  const [userProfileRightOpen, setUserProfileRightOpen] = useState(false)

  // ** Hooks
  const theme = useTheme()
  const { settings } = useSettings()
  const dispatch = useDispatch()
  const hidden = useMediaQuery(theme.breakpoints.down('lg'))

  const store = useSelector(state => state.Tinder)


  // ** Vars
  const { skin } = settings
  const smAbove = useMediaQuery(theme.breakpoints.up('sm'))
  const sidebarWidth = smAbove ? 370 : 300
  const mdAbove = useMediaQuery(theme.breakpoints.up('md'))

  const [chat, setChat] = useState(true)
  const [headImg, setHaedImg] = useState('/images/tinder/1.jpg')
  const [fetchLoading, setFetchLoading] = useState(true)

  useEffect(() => {
    Promise.allSettled([dispatch(fetchUserProfile()), dispatch(fetchChatsContacts())]).finally(() => {
      setFetchLoading(false)
    })
  }, [dispatch])
  const handleLeftSidebarToggle = () => setLeftSidebarOpen(prev => !prev)
  const handleUserProfileLeftSidebarToggle = () => setUserProfileLeftOpen(prev => !prev)
  const handleUserProfileRightSidebarToggle = () => setUserProfileRightOpen(prev => !prev)

  return (
    <>
      <Box
        className='app-chat'
        sx={{
          width: '100%',
          display: 'flex',
          borderRadius: 1,
          position: 'relative',
          minHeight: 'calc(var(--vh2) * 100 - 90px)',
          boxShadow: skin === 'bordered' ? 0 : 6,
          ...(skin === 'bordered' && { border: `1px solid ${theme.palette.divider}` })
        }}
      >
        {fetchLoading ? (
          <ContentLoading />
        ) : (
          <>
        <TinderSideBar
          store={store}
          hidden={hidden}
          mdAbove={mdAbove}
          dispatch={dispatch}
          userStatus={userStatus}
          selectMessage={selectMessage}
          getInitials={getInitials}
          sidebarWidth={sidebarWidth}
          setUserStatus={setUserStatus}
          leftSidebarOpen={leftSidebarOpen}
          removeSelectedChat={removeSelectedChat}
          userProfileLeftOpen={userProfileLeftOpen}
          formatDateToMonthShort={formatDateToMonthShort}
          handleLeftSidebarToggle={handleLeftSidebarToggle}
          handleUserProfileLeftSidebarToggle={handleUserProfileLeftSidebarToggle}
          headImg={headImg}
          setChat={setChat}
          chat={chat}
          setHaedImg={setHaedImg}
        />
        {chat && (
          <TinderContent
            store={store}
            hidden={hidden}
            mdAbove={mdAbove}
            dispatch={dispatch}
            getInitials={getInitials}
            sidebarWidth={sidebarWidth}
            userProfileRightOpen={userProfileRightOpen}
            handleLeftSidebarToggle={handleLeftSidebarToggle}
            handleUserProfileRightSidebarToggle={handleUserProfileRightSidebarToggle}
            headImg={headImg}
            setHaedImg={setHaedImg}
          />
        )}

        {chat === false ? (
          <TinderContacts
            store={store}
            hidden={hidden}
            mdAbove={mdAbove}
            dispatch={dispatch}
            getInitials={getInitials}
            sidebarWidth={sidebarWidth}
            userProfileRightOpen={userProfileRightOpen}
            handleLeftSidebarToggle={handleLeftSidebarToggle}
            handleUserProfileRightSidebarToggle={handleUserProfileRightSidebarToggle}
            headImg={headImg}
            setHaedImg={setHaedImg}
            callData={callData}
          />
        ) : (
          ''
        )}
          </>
        )}
      </Box>
    </>
  )
}

Tinder.contentHeightFixed = true

export default Tinder
